import { render, staticRenderFns } from "./TrashedComment.vue?vue&type=template&id=5edba00a&scoped=true"
import script from "./TrashedComment.vue?vue&type=script&lang=js"
export * from "./TrashedComment.vue?vue&type=script&lang=js"
import style0 from "./TrashedComment.vue?vue&type=style&index=0&id=5edba00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edba00a",
  null
  
)

export default component.exports